"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _react = _interopRequireDefault(require("react"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _zorseControls = require("crm_ui/zorse/zorseControls");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var errorMap = {
  '403': {
    illustration: 'keys',
    learnMoreLink: 'https://knowledge.hubspot.com/getting-started-with-hubspot-sales/an-overview-of-team-management#4-set-the-user-s-permissions'
  }
};

var ErrorPage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ErrorPage, _PureComponent);

  function ErrorPage() {
    var _this;

    (0, _classCallCheck2.default)(this, ErrorPage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ErrorPage).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(ErrorPage, [{
    key: "openZorse",
    value: function openZorse(link) {
      (0, _zorseControls.openDocument)(link);
    }
  }, {
    key: "getZorseLink",
    value: function getZorseLink() {
      var link = errorMap[this.props.errorCode].learnMoreLink;

      if (!link) {
        return undefined;
      }

      return _react.default.createElement(_UILink.default, {
        className: "p-left-1",
        external: true,
        onClick: this.partial(this.openZorse, link)
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "errorPage.learnMore"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errorCode = _this$props.errorCode,
          objectType = _this$props.objectType;
      return _react.default.createElement(_UIErrorMessage.default, {
        illustration: errorMap[errorCode].illustration,
        illustrationProps: {
          width: 200
        },
        title: _I18n.default.text("errorPage.title." + errorCode, {
          objectType: _I18n.default.text("genericTypes.singular." + objectType)
        })
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        "data-selenium-test": "error-message",
        message: "errorPage.body." + errorCode
      }), this.getZorseLink()));
    }
  }]);
  return ErrorPage;
}(_PureComponent2.default);

exports.default = ErrorPage;
ErrorPage.defaulProps = _UIErrorMessage.default.defaultProps;
ErrorPage.propTypes = _UIErrorMessage.default.propTypes;
module.exports = exports.default;